"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalDateTime = void 0;
exports.toLocalDateTime = toLocalDateTime;
const tslib_1 = require("tslib");
/* eslint-disable ml-rules/new-date */
const moment_timezone_1 = tslib_1.__importDefault(require("moment-timezone"));
const local_date_1 = require("./local-date");
const utils_1 = require("./utils");
/**
 * A LocalDateTime represents a date-time with no time zone in the ISO-8601 calendar system.
 */
class LocalDateTime extends local_date_1.LocalDate {
    static now() {
        const now = (0, moment_timezone_1.default)();
        return toLocalDateTime(now);
    }
    static from(year, month, day, hour, minutes, seconds, ms) {
        const now = LocalDateTime.now();
        return now
            .setYear(year)
            .setMonth(month !== null && month !== void 0 ? month : 0)
            .setDate(day !== null && day !== void 0 ? day : 1)
            .setHour(hour !== null && hour !== void 0 ? hour : 0)
            .setMinute(minutes !== null && minutes !== void 0 ? minutes : 0)
            .setSecond(seconds !== null && seconds !== void 0 ? seconds : 0)
            .setMillisecond(ms !== null && ms !== void 0 ? ms : 0);
    }
    constructor(_symbol, date, options) {
        super(_symbol, date, options);
        this._type_ = 'local-datetime';
    }
    addMilliseconds(ms) {
        const newDate = this.moment.add(ms, 'ms');
        return this.new(newDate);
    }
    addSeconds(sec) {
        const newDate = this.moment.add(sec, 'seconds');
        return this.new(newDate);
    }
    addMinutes(minutes) {
        const newDate = this.moment.add(minutes, 'minutes');
        return this.new(newDate);
    }
    subMinutes(minutes) {
        const newDate = this.moment.subtract(minutes, 'minutes');
        return this.new(newDate);
    }
    subSeconds(seconds) {
        const newDate = this.moment.subtract(seconds, 'seconds');
        return this.new(newDate);
    }
    subMilliseconds(ms) {
        const newDate = this.moment.subtract(ms, 'milliseconds');
        return this.new(newDate);
    }
    addHours(hours) {
        const newDate = this.moment.add(hours, 'hours');
        return this.new(newDate);
    }
    setHour(hour) {
        const newDate = this.moment.hour(hour);
        return this.new(newDate);
    }
    setMinute(minute) {
        const newDate = this.moment.minute(minute);
        return this.new(newDate);
    }
    setSecond(sec) {
        const newDate = this.moment.second(sec);
        return this.new(newDate);
    }
    setMillisecond(ms) {
        const newDate = this.moment.millisecond(ms);
        return this.new(newDate);
    }
    startOf(unit) {
        const normalizedUnit = (0, utils_1.normalizeUnit)(unit);
        const newDate = this.moment.startOf(normalizedUnit);
        return this.new(newDate);
    }
    endOf(unit) {
        const normalizedUnit = (0, utils_1.normalizeUnit)(unit);
        const newDate = this.moment.endOf(normalizedUnit);
        return this.new(newDate);
    }
    getHours() {
        return this.moment.get('hour');
    }
    getMinutes() {
        return this.moment.get('minutes');
    }
    getSeconds() {
        return this.moment.get('seconds');
    }
    getMilliseconds() {
        return this.moment.get('milliseconds');
    }
    isStartOfDay() {
        return (this.getHours() === 0 &&
            this.getMinutes() === 0 &&
            this.getSeconds() === 0);
    }
    humanize(formats) {
        return this.moment.calendar(Object.assign({ sameElse: 'L, LT' }, formats));
    }
    toDate() {
        const currentMoment = this.moment;
        return new Date(currentMoment.get('year'), currentMoment.get('month'), currentMoment.get('date'), currentMoment.get('hour'), currentMoment.get('minute'), currentMoment.get('second'), currentMoment.get('millisecond'));
    }
    formatForServer() {
        return this.format('YYYY-MM-DDTHH:mm:ss.SSS');
    }
    toTimeString(withSeconds = false) {
        return withSeconds ? this.format('HH:mm:ss') : this.format('HH:mm');
    }
    toDayString() {
        return this.format('LL');
    }
}
exports.LocalDateTime = LocalDateTime;
function toLocalDateTime(date) {
    return date ? new LocalDateTime(local_date_1.constructSymbol, date) : undefined;
}
